import { useDispatch } from 'react-redux';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider} from '@mui/material';
import React from 'react'
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import {
    fetchClearEvaluacionesActualizarPeriodo
    } from "../../../redux/Evaluaciones/EvaluacionesSlice";

export const InfoActualizacionPeriodoModal = ({open, setOpen, listaMensajesActualizacionPeriodo}) => {

    const dispatch = useDispatch();

    const clear = () => {
        dispatch(fetchClearEvaluacionesActualizarPeriodo());
        setOpen(false);
    }

  return (
    <Dialog 
    PaperProps={{ sx: { width: "50%", height: "70%" } }}
    open={open}
    maxWidth='lg'
    >
        <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>Informaciones</DialogTitle>
        <Divider />

        <DialogContent>

        <Stack sx={{ width: '100%' }} spacing={2}>

            {
                listaMensajesActualizacionPeriodo.listaMensajes?.map((item, index) => 
                    <Alert severity="error" key={index}>{item}</Alert>
                )
            }
            
            <Alert severity="success"><b>{listaMensajesActualizacionPeriodo.cantidadEvaluacionesActualizadas}</b> evaluaciones fueron actualizadas</Alert>
            <Alert severity="info"><b>{listaMensajesActualizacionPeriodo.cantidadEvaluacionesNoActualizadas}</b> evaluaciones no fueron actualizadas</Alert>

        </Stack>

        </DialogContent>

        <DialogActions className='justify-content-center'>
            <button onClick={() => clear()} className='btn btn-primary-mem'>Aceptar</button>
        </DialogActions>

    </Dialog>
  )
}
